export const APPLY_DEALER_PAYMENT_OVERRIDES = 'APPLY_DEALER_PAYMENT_OVERRIDES';

export const OFFER_SAVE_FAILURE = 'OFFER_SAVE_FAILURE';
export const OFFER_SAVE_NOCHANGE_REQUEST = 'OFFER_SAVE_NOCHANGE_REQUEST';
export const OFFER_SAVE_NOCHANGE_SUCCESS = 'OFFER_SAVE_NOCHANGE_SUCCESS';
export const OFFER_SAVE_REQUEST = 'OFFER_SAVE_REQUEST';
export const OFFER_SAVE_SUCCESS = 'OFFER_SAVE_SUCCESS';
export const LINKS_REQUEST = 'LINKS_REQUEST';
export const LINKS_SUCCESS = 'LINKS_SUCCESS';
export const LINKS_FAILURE = 'LINKS_FAILURE';
export const SOFT_SAVE_REQUEST = 'SOFT_SAVE_REQUEST';
export const SOFT_SAVE_SUCCESS = 'SOFT_SAVE_SUCCESS';
export const SOFT_SAVE_FAILURE = 'SOFT_SAVE_FAILURE';
export const OFFER_SUBMISSION_FAILURE = 'OFFER_SUBMISSION_FAILURE';
export const OFFER_SUBMISSION_REQUEST = 'OFFER_SUBMISSION_REQUEST';
export const OFFER_SUBMISSION_SUCCESS = 'OFFER_SUBMISSION_SUCCESS';

export const PROGRAMS_SELECT = 'PROGRAMS_SELECT';
export const PROGRAMS_END_DAYS = 'PROGRAMS_END_DAYS';
export const PROGRAMS_CLEAR_ALL = 'PROGRAMS_CLEAR_ALL';
export const PROGRAMS_CLEAR_SELECTED = 'PROGRAMS_CLEAR_SELECTED';
export const PROGRAMS_CLEAR_INCENTIVES = 'PROGRAMS_CLEAR_INCENTIVES';
export const SET_RETAINED_PROGRAM_DISPLAY = 'SET_RETAINED_PROGRAM_DISPLAY';
export const CLEAR_RETAINED_PROGRAM_DISPLAY = 'CLEAR_RETAINED_PROGRAM_DISPLAY';
export const HOLD_PROGRAM_FALLBACK_VALUES = 'HOLD_PROGRAM_FALLBACK_VALUES';
export const RELEASE_PROGRAM_FALLBACK_VALUES = 'RELEASE_PROGRAM_FALLBACK_VALUES';
export const MARK_PROGRAM_LOOKUP_PENDING = 'MARK_PROGRAM_LOOKUP_PENDING';
export const RESOLVE_PROGRAM_LOOKUP = 'RESOLVE_PROGRAM_LOOKUP';
export const DISCARD_PROGRAM_LOOKUP_PENDING = 'DISCARD_PROGRAM_LOOKUP_PENDING';
export const SET_PENDING_APPLY_PROGRAM = 'SET_PENDING_APPLY_PROGRAM';
export const CLEAR_PENDING_APPLY_PROGRAM = 'CLEAR_PENDING_APPLY_PROGRAM';
export const SET_APPLIED_PAYMENT_BASELINE = 'SET_APPLIED_PAYMENT_BASELINE';
export const CLEAR_APPLIED_PAYMENT_BASELINE = 'CLEAR_APPLIED_PAYMENT_BASELINE';
export const SET_ALL_TIERS_LOADED = 'SET_ALL_TIERS_LOADED';
export const ALL_PROGRAMS_LOADED = 'ALL_PROGRAMS_LOADED';
export const PROGRAMS_INCENTIVES_REQUEST = 'PROGRAMS_INCENTIVES_REQUEST';
export const PROGRAMS_INCENTIVES_REQUEST_FAILURE = 'PROGRAMS_INCENTIVES_REQUEST_FAILURE';
export const PROGRAMS_INCENTIVES_REQUEST_SUCCESS = 'PROGRAMS_INCENTIVES_REQUEST_SUCCESS';

export const REQUEST_PROGRAMS = 'REQUEST_PROGRAMS';
export const REQUEST_PROGRAMS_FAILURE = 'REQUEST_PROGRAMS_FAILURE';
export const REQUEST_PROGRAMS_SUCCESS = 'REQUEST_PROGRAMS_SUCCESS';

export const OPEN_PROGRAMS_SLIDEOUT = 'OPEN_PROGRAMS_SLIDEOUT';
export const CLOSE_PROGRAMS_SLIDEOUT = 'CLOSE_PROGRAMS_SLIDEOUT';

export const SAVE_OFFER = 'SAVE_OFFER';
export const SAVE_OFFER_WITH_CANCEL_PENDING = 'SAVE_OFFER_WITH_CANCEL_PENDING';
export const SAVE_OFFER_AFTER_CANCEL = 'SAVE_OFFER_AFTER_CANCEL';
export const SEND_TO_DEALER_TRACK = 'SEND_TO_DEALER_TRACK';
export const SELECTED_ANNUAL_MILES = 'SELECTED_ANNUAL_MILES';
export const SELECTED_TERM = 'SELECTED_TERM';
export const SUBMIT_OFFER = 'SUBMIT_OFFER';
export const TOGGLE_INCENTIVE_FOR_PROGRAM = 'TOGGLE_INCENTIVE_FOR_PROGRAM';
export const COBUYER_SHOW_INVALID_MODAL = 'COBUYER_SHOW_INVALID_MODAL';
export const MARK_GTL_BANNER_SHOWN_ON_LOAD = 'MARK_GTL_BANNER_SHOWN_ON_LOAD';

export const SET_PENDING_REVIEW_CONTEXT = 'SET_PENDING_REVIEW_CONTEXT';
export const SET_PENDING_REVIEW_RESOLUTION_PATH = 'SET_PENDING_REVIEW_RESOLUTION_PATH';
export const MARK_PENDING_REVIEW_HANDLED = 'MARK_PENDING_REVIEW_HANDLED';
export const SET_PENDING_REVIEW_TARGET_VERSION = 'SET_PENDING_REVIEW_TARGET_VERSION';
export const SET_PENDING_REVIEW_RESOLUTION = 'SET_PENDING_REVIEW_RESOLUTION';
export const CLEAR_PENDING_REVIEW = 'CLEAR_PENDING_REVIEW';
export const FETCH_DEALER_REVIEW_BAGGAGE_REQUEST = 'FETCH_DEALER_REVIEW_BAGGAGE_REQUEST';
export const FETCH_DEALER_REVIEW_BAGGAGE_SUCCESS = 'FETCH_DEALER_REVIEW_BAGGAGE_SUCCESS';
export const FETCH_DEALER_REVIEW_BAGGAGE_FAILURE = 'FETCH_DEALER_REVIEW_BAGGAGE_FAILURE';
export const RESOLVE_PENDING_REVIEW_REQUESTED = 'RESOLVE_PENDING_REVIEW_REQUESTED';
export const RESOLVE_PENDING_DEALER_REVIEW_PAYMENT = 'RESOLVE_PENDING_DEALER_REVIEW_PAYMENT';
export const CLEAR_SOCKET_EVENT_NOTIFICATION = 'CLEAR_SOCKET_EVENT_NOTIFICATION';
export const MAKE_CURRENT = 'MAKE_CURRENT';
export const MAKE_CURRENT_COMPLETED = 'MAKE_CURRENT_COMPLETED';

export const UPDATE_SELECTED_INCENTIVES = 'UPDATE_SELECTED_INCENTIVES';

export const DISABLE_PROGRAM_LOSS_INCENTIVES = 'DISABLE_PROGRAM_LOSS_INCENTIVES';
export const CLEAR_PROGRAM_LOSS_INCENTIVES = 'CLEAR_PROGRAM_LOSS_INCENTIVES';
export const PRUNE_PROGRAM_LOSS_INCENTIVES = 'PRUNE_PROGRAM_LOSS_INCENTIVES';
export const MARK_PROGRAM_AUTO_SELECTED = 'MARK_PROGRAM_AUTO_SELECTED';
export const CLEAR_PROGRAM_AUTO_SELECTED = 'CLEAR_PROGRAM_AUTO_SELECTED';
export const UPDATED_ACQFEE_OVERRIDE = 'UPDATED_ACQFEE_OVERRIDE';
export const UPDATED_ACQFEE_UPFRONT_OVERRIDE = 'UPDATED_ACQFEE_UPFRONT_OVERRIDE';
export const UPDATED_ADJUSTED_RESIDUAL_DOLLAR_OVERRIDE = 'UPDATED_ADJUSTED_RESIDUAL_DOLLAR_OVERRIDE';
export const UPDATED_ADJUSTED_RESIDUAL_PERCENT_OVERRIDE = 'UPDATED_ADJUSTED_RESIDUAL_PERCENT_OVERRIDE';
export const UPDATED_BALLOON_PAYMENT_AMOUNT = 'UPDATED_BALLOON_PAYMENT_AMOUNT';
export const UPDATED_BALLOON_TYPE = 'UPDATED_BALLOON_TYPE';
export const UPDATED_BASE_RESIDUAL_DOLLAR_OVERRIDE = 'UPDATED_BASE_RESIDUAL_DOLLAR_OVERRIDE';
export const UPDATED_BASE_RESIDUAL_PERCENT_OVERRIDE = 'UPDATED_BASE_RESIDUAL_PERCENT_OVERRIDE';
export const UPDATED_BUY_RATE_OVERRIDE = 'UPDATED_BUY_RATE_OVERRIDE';
export const UPDATED_CREDIT_DECISION_ENABLED = 'UPDATED_CREDIT_DECISION_ENABLED';
export const UPDATED_CREDIT_DECISION_LENDER_NAME = 'UPDATED_CREDIT_DECISION_LENDER_NAME';
export const UPDATED_CREDIT_DECISION_LENDER = 'UPDATED_CREDIT_DECISION_LENDER';
export const UPDATED_CREDIT_DECISION_STATUS = 'UPDATED_CREDIT_DECISION_STATUS';
export const UPDATED_CREDIT_DECISION_TOGGLE = 'UPDATED_CREDIT_DECISION_TOGGLE';
export const UPDATED_DOWN_PAYMENT_IMMEDIATE = 'UPDATED_DOWN_PAYMENT_IMMEDIATE';
export const UPDATED_INCENTIVES_TOTAL_OVERRIDE = 'UPDATED_INCENTIVES_TOTAL_OVERRIDE';
export const UPDATED_MANUAL_INCENTIVES = 'UPDATED_MANUAL_INCENTIVES';
export const UPDATED_OFFER_PRICE_IMMEDIATE = 'UPDATED_OFFER_PRICE_IMMEDIATE';
export const UPDATED_RETAIL_PRICE_OVERRIDE = 'UPDATED_RETAIL_PRICE_OVERRIDE';
export const UPDATED_SECURITY_DEPOSIT_OVERRIDE = 'UPDATED_SECURITY_DEPOSIT_OVERRIDE';
export const UPDATED_MAX_RESIDUALIZED_MSRP_OVERRIDE = 'UPDATED_MAX_RESIDUALIZED_MSRP_OVERRIDE';
export const UPDATED_SELL_RATE_OVERRIDE = 'UPDATED_SELL_RATE_OVERRIDE';
export const UPDATE_DEAL_REF_ID = 'UPDATE_DEAL_REF_ID';

export const UPDATED_TOTAL_TAX_OVERRIDE = 'UPDATED_TOTAL_TAX_OVERRIDE';
export const UPDATED_TOTAL_TAX_UPFRONT_OVERRIDE = 'UPDATED_TOTAL_TAX_UPFRONT_OVERRIDE';
export const UPDATE_TAX_ITEMS = 'UPDATE_TAX_ITEMS';

export const PAYMENT_FEES_TYPES_REQUEST = 'PAYMENT_FEES_TYPES_REQUEST';
export const PAYMENT_FEES_TYPES_FAILURE = 'PAYMENT_FEES_TYPES_FAILURE';
export const PAYMENT_FEES_TYPES_SUCCESS = 'PAYMENT_FEES_TYPES_SUCCESS';
export const UPDATE_PAYMENT_FEES_OVERRIDE = 'UPDATE_PAYMENT_FEES_OVERRIDE';
export const UPDATE_CURRENT_CALCULATION_ENDPOINT = 'UPDATE_CURRENT_CALCULATION_ENDPOINT';
export const CLEAR_OVERRIDES = 'CLEAR_OVERRIDES';

export const SET_SOFT_PULL_CONSENT_PROVIDED = 'SET_SOFT_PULL_CONSENT_PROVIDED';
export const SET_SHOW_SOFT_PULL_CONSENT_MODAL = 'SET_SHOW_SOFT_PULL_CONSENT_MODAL';
export const SET_CREDIT_RATING_DISPLAY_TYPE = 'SET_CREDIT_RATING_DISPLAY_TYPE';
export const PROGRAMS_SET_CREDIT_SCORE_OVERRIDE = 'PROGRAMS_SET_CREDIT_SCORE_OVERRIDE';
